import { useEffect, useRef, useState } from 'react';

// `text` is a dependency because content growing inside a fixed-width box resizes
// nothing, so the ResizeObserver alone never fires.
export const useTextOverflow = <T extends HTMLElement>(text?: string) => {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    const measure = () =>
      setIsOverflowing(element.scrollWidth > element.clientWidth);

    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);

    return () => observer.disconnect();
  }, [text]);

  return { ref, isOverflowing };
};
